import { create } from 'zustand';

export const useViewsData = create((set) => ({
  viewsData: null,
  setViewsData: (data: any) => set(() => ({ viewsData: data }))
}));

export const useClusterData = create((set) => ({
  clusterData: null,
  setClusterData: (data: any) => set(() => ({ clusterData: data }))
}));

export const useClusterSelected = create((set) => ({
  clusterSelected: null,
  setClusterSelected: (cluster: string) => set(() => ({ clusterSelected: cluster }))
}));

export const useIsModalOpenedCluster = create((set) => ({
  isModalOpened: false,
  setIsModalOpened: (open: boolean) => set(() => ({ isModalOpened: open }))
}));

export const useIsLoadingCluster = create((set) => ({
  isLoading: false,
  setIsLoading: (loading: boolean) => set(() => ({ isLoading: loading }))
}));

export const useClusterOptionsSelected = create((set) => ({
  clusterOptionsSelected: [],
  setClusterOptionsSelected: (cluster: any) => set(() => ({ clusterOptionsSelected: cluster }))
}));

export const useClustersSaved = create((set) => ({
  clustersSaved: [],
  setClustersSaved: (cluster: any) => set(() => ({ clustersSaved: cluster }))
}));

export const useTotalClusters = create((set) => ({
  clusters: 0,
  setClusters: (number: number) => set(() => ({ clusters: number }))
}));

export const useDownloadClick = create((set) => ({
  isClick: false,
  setIsClick: (click: boolean) => set(() => ({ isClick: click }))
}));

export const useViewRunSelected = create((set) => ({
  view: 'No Selection',
  setView: (view: string) => set(() => ({ view: view }))
}));

export const useNoSelectionOpen = create((set) => ({
  isOpen: false,
  setIsOpen: (open: boolean) => set(() => ({ isOpen: open }))
}));

export const useClusterButtonGoStatus = create((set) => ({
  isClicked: false,
  setIsClicked: (doClick: boolean) => set(() => ({ isClicked: doClick }))
}));

export const useClearSelectionClicked = create((set) => ({
  clearData: false,
  setClearData: (clear: boolean) => set(() => ({ clearData: clear }))
}));

export const useChkClicked = create((set) => ({
  isClicked: false,
  setIsClicked: (click: boolean) => set(() => ({ isClicked: click }))
}));

export const useLessRowsSignals = create((set) => ({
  isLessRows: false,
  setIsLessRows: (lessRows: boolean) => set(() => ({ isLessRows: lessRows }))
}));

export const useDataSignals = create((set) => ({
  data: [],
  setData: (data: any) => set(() => ({ data: data }))
}));

export const useClusterCounter = create((set) => ({
  counter: 0,
  setCounter: (amount: number) => set(() => ({ counter: amount }))
}));

export const useAccordionUICluster = create((set) => ({
  accordionData: null,
  setAccordion: (data: any) => set(() => ({ accordionData: data }))
}));

export const useClusterViewsData = create((set) => ({
  viewDataSelected: [],
  setViewDataSelected: (data: any[]) => set(() => ({ viewDataSelected: data }))
}));

export const useReportClusterData = create((set) => ({
  reportsData: null,
  setReportsData: (data: any) => set(() => ({ reportsData: data }))
}));

export const usuSignalsValuesUpdatedFromAI = create((set) => ({
  updated: false,
  setUpdated: (isUpdated: boolean) => set(() => ({ updated: isUpdated }))
}));

export const useExclusionValues = create((set) => ({
  valuesExcluded: [],
  setValuesExcluded: (values: any) => set(() => ({ valuesExcluded: values }))
}));

export const useReRunButtonStatus = create((set) => ({
  isDisabled: true,
  setIsDisabled: (disable: boolean) => set(() => ({ isDisabled: disable }))
}));

export const useExclusionPayloadValues = create((set) => ({
  valuesPayloadExcluded: [],
  setValuesPayloadExcluded: (values: any) => set(() => ({ valuesPayloadExcluded: values }))
}));

export const useEnableGoButton = create((set) => ({
  enableButton: false,
  setEnableButton: (isUpdated: boolean) => set(() => ({ enableButton: isUpdated }))
}));

export const useShowUpClusterDataAI = create((set) => ({
  isClicked: false,
  setIsClicked: (doClick: boolean) => set(() => ({ isClicked: doClick }))
}));

export const useStepsPathWheeler = create((set) => ({
  isLastStep: false,
  setIsLastStep: (isLastStep: boolean) => set(() => ({ isLastStep: isLastStep }))
}));

export const usePayloadAIExplainerSignals = create((set) => ({
  data: null,
  setData: (data: any) => set(() => ({ data: data }))
}));

export const useShowAIExplainerSignals = create((set) => ({
  showExplainer: false,
  setShowExplainer: (showExplainer: boolean) => set(() => ({ showExplainer: showExplainer }))
}));

export const useAIExplainerSignals = create((set) => ({
  explainer: '',
  setExplainer: (explainer: string) => set(() => ({ explainer: explainer }))
}));

export const useAIExplainerSignalsArray = create((set) => ({
  explainer: [],
  setExplainer: (explainer: any) => set(() => ({ explainer: explainer }))
}));

export const useErrorSignalsDesc = create((set) => ({
  desc: false,
  setDesc: (desc: string) => set(() => ({ desc: desc }))
}));

export const useShowModal = create((set) => ({
  showModal: false,
  setShowModal: (showModal: boolean) => set(() => ({ showModal: showModal }))
}));

export const useIsEmptySignals = create((set) => ({
  isEmpty: false,
  setIsEmpty: (isEmpty: boolean) => set(() => ({ isEmpty: isEmpty }))
}));

interface PredictiveState {
  target: any[];
  exclude?: string[];
}
interface PredictiveStore {
  predictive: PredictiveState | null;
  setPredictive: (data: { target: any[]; exclude?: string[] }) => void;
  clearPredictive: () => void;
}
export const usePredictiveStore = create<PredictiveStore>((set) => ({
  predictive: null,
  setPredictive: (data) =>
    set({
      predictive: {
        target: data.target
      }
    }),
  clearPredictive: () => set({ predictive: null })
}));
